'use strict';

angular.module('mx.SolutionBuilderAgent').controller('mx.SolutionBuilderAgent.OpenReportFromActionController', [
	'mx.shell.Config',
	'$httpParamSerializer',
	'$window',
	function openReportFromActionController(config, $httpParamSerializer, $window) {
		const vm = this;

		vm.execute = function (selectedObjects, action) {
			const parameters = getQueryParameters(action.controllerParams);

			let reportControlUrl = parameters.ReportControlUrl;

			delete parameters.ReportControlUrl;
			if (!parameters.ReportName) {
				throw new Error("Action Open Report: does not contain parameter 'ReportName'");
			}
			if (!reportControlUrl) {
				throw new Error("Action Open Report: does not contain parameter 'ReportControlUrl'");
			}
			parameters.TypeName = '';
			parameters.ObjId = '';
			if (selectedObjects && selectedObjects.length === 1) {
				const selectedObject = selectedObjects[0];

				parameters.TypeName = selectedObject._type;
				parameters.ObjId = selectedObject._id;
			}
			const rootPath = config.get('reportingHosts').default;
			const match = reportControlUrl.match(/^\/*/g)[0];

			reportControlUrl = reportControlUrl.replace(match, '/');
			$window.open(rootPath + reportControlUrl + '?' + $httpParamSerializer(parameters));
		};
	},
]);

function getQueryParameters(query) {
	const result = {};
	const vars = query.split('&');

	for (let i = 0; i < vars.length; i++) {
		const pair = vars[i].split('=');
		const key = pair[0];
		const value = decodeURIComponent(pair[1]);

		if (!result.hasOwnProperty(key)) {
			result[key] = value;
		} else if (Array.isArray(result[key])) {
			result[key].push(value);
		} else {
			result[key] = [result[key], value];
		}
	}
	return result;
}
